import { useState } from 'react'
import { Box, Chip, Popover, Typography, IconButton } from '@mui/material'
import colors from 'theme/colors'
import { ColumnDescriptionWithoutTitle } from 'constants/tableData'
import { FilterAlt } from '@mui/icons-material'

interface FleetColumnHeaderProps {
  availableCodeTypes: string[]
  selectedTypes: string[]
  onFilterChange: (selectedTypes: string[]) => void
}

const FleetColumnHeader: React.FC<FleetColumnHeaderProps> = ({
  availableCodeTypes,
  selectedTypes,
  onFilterChange,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (codeType: string) => {
    const newSelectedTypes = selectedTypes.includes(codeType)
      ? selectedTypes.filter(type => type !== codeType)
      : [...selectedTypes, codeType]
    
    onFilterChange(newSelectedTypes)
  }

  const open = Boolean(anchorEl)

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <IconButton 
        size="small" 
        onClick={handleClick}
        sx={{ 
          marginLeft: 1,
          backgroundColor: open ? colors.grey[200] : 'transparent',
          '&:hover': { backgroundColor: colors.grey[200] }
        }}
      >
        <FilterAlt fontSize="small" />
      </IconButton>
      <Box sx={{ flex: 1 }}>
        <ColumnDescriptionWithoutTitle description="FLEET IDENTIFIERS" />
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            padding: 2,
            marginTop: 0.5,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }}
      >
        <Typography variant="body2" sx={{ marginBottom: 1, fontWeight: 500 }}>
          Show Identifiers:
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', maxWidth: '300px' }}>
          {availableCodeTypes.map((codeType) => (
            <Chip
              key={codeType}
              label={codeType}
              size="small"
              onClick={() => handleChange(codeType)}
              sx={{
                backgroundColor: selectedTypes.includes(codeType) 
                  ? colors.primary 
                  : colors.grey[100],
                color: selectedTypes.includes(codeType) 
                  ? '#fff' 
                  : colors.grey[600],
                '&:hover': {
                  backgroundColor: selectedTypes.includes(codeType) 
                    ? colors.primary 
                    : colors.grey[200],
                },
                fontWeight: 500,
                cursor: 'pointer'
              }}
            />
          ))}
        </Box>
      </Popover>
    </Box>
  )
}

export default FleetColumnHeader 